import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppConfig } from '@enus/model/app-config';
import { APP_CONFIG } from "@enus/services/app-config.service";

fetch('/assets/runtime-config.json')
    .then((response) => response.json())
    .then((config: AppConfig) => {
        if (environment.production) {
            enableProdMode();
        }

        let isBackofficeEntryLink = false;
        if (window?.location) {
            const paramsString = window.location.search;
            let searchParams = new URLSearchParams(paramsString);
            isBackofficeEntryLink = searchParams.has('backofficeLink');
        }

        if (isBackofficeEntryLink) {
            config.isBackofficeEntryLink = isBackofficeEntryLink;
        }

        platformBrowserDynamic([{ provide: APP_CONFIG, useValue: config }])
            .bootstrapModule(AppModule)
            .catch((err) => console.error(err));
    })
    .catch(() =>
        platformBrowserDynamic([{ provide: APP_CONFIG, useValue: environment }])
            .bootstrapModule(AppModule)
            .catch((err) => console.error(err)),
    );
